import { getBaseUrl } from "@api/helpers/url/baseUrl";
import { getRelativePathForImage } from "@api/helpers/url/imageUrl";
import { getBackend } from "@service/router/getters";

export const getImageUrl = (backend: string | undefined, id: string | undefined | null, width?: number, fileName?: string) => {
    if(!backend) {
        backend = getBackend(backend);
    }

    return backend && id ? getBaseUrl(backend) + getRelativePathForImage(id, width, fileName) : "";
}